import { ignoredMessages } from './constants';
import { checkIgnore } from './utils';
export const rollbarConfig = {
    enabled: process.env.APP_ENV !== 'development',
    environment: process.env.APP_ENV,
    accessToken: process.env.ROLLBAR_CLIENT_TOKEN,
    captureUncaught: false,
    captureUnhandledRejections: true,
    checkIgnore,
    ignoredMessages,
    payload: {
        client: {
            javascript: {
                source_map_enabled: true,
                code_version: process.env.CODE_VERSION,
            },
        },
    },
};
